<template>
    <a-modal title="新增银行账户"
             :width="550"
             :visible="visible"
             @cancel="$emit('cancel')"
             @ok="onsubmit"
             :maskClosable="false"
             :destroyOnClose="true"
             :confirmLoading="modalLoading">
        <a-form :form="form">
            <table style="width:100%;height: 300px;" class="fx-form">
                <tr>
                    <th>机构名称:</th>
                    <td>
                        <a-form-item>
                            <a-form-item>
                                <org-selector
                                        v-decorator="['orgId',{initialValue:initData.orgId,rules:[{ required: true, message: '机构不能为空'}]}]"
                                        @change="onOrgChange"
                                />
                            </a-form-item>
                        </a-form-item>
                    </td>
                </tr>
                <tr>
                    <th> 银行帐号：</th>
                    <td>
                        <a-form-item>
                            <a-input
                                    style="width: 300px;"
                                    v-decorator="['bankAccount',{initialValue:initData.bankAccount,rules: [{ required: true, message: '银行帐号不能为空'}]}]"
                            />
                        </a-form-item>
                    </td>
                </tr>

                <tr>
                    <th>账户名称：</th>
                    <td>
                        <a-form-item>
                            <a-input
                                    style="width: 300px;"
                                    v-decorator="['bankAccountName',{initialValue:initData.bankAccountName,rules: [{required:true,message:'账户名称不能为空'}]}]"
                            />
                        </a-form-item>
                    </td>
                </tr>

                <tr>
                    <th>开户银行：</th>
                    <td>
                        <a-form-item>
                            <a-input
                                    style="width: 300px;"
                                    v-decorator="['bankName',{initialValue:initData.bankName,rules:[{ required: true, message: '开户银行不能为空'}]}]"
                            />
                        </a-form-item>
                    </td>
                </tr>
                 <tr>
                    <th>类型：</th>
                    <td>
                        <a-form-item>
                            <a-select
                                v-decorator="[
                                  'useType',
                                  { initialValue:initData.useType,rules: [{ required: true, message: '类型不能为空!' }] },
                                ]"
                                placeholder="请选择类型"
                                @change="handleUseTypeChange"
                              >
                                <a-select-option value="0">
                                  默认
                                </a-select-option>
                                <a-select-option value="1">
                                  非默认
                                </a-select-option>
                              </a-select>
                        </a-form-item>
                    </td>
                </tr>
                <tr v-if="showUnitCodeEdit">
                    <th>绑定采购单位：</th>
                    <td>
                        <a-form-item  help="请输入采购单位的信用代码，用英文逗号隔开">
                            <a-textarea auto-size
                                    placeholder="请输入采购单位的信用代码，用英文逗号隔开"
                                    v-decorator="['purchaseUnitCode',{initialValue:initData.purchaseUnitCode,rules:[{ required: true, message: '请输入采购单位的信用代码，用英文逗号隔开'}]}]"
                            />
                        </a-form-item>
                    </td>
                </tr>
                <tr>
                    <th>状态：</th>
                    <td>
                        <a-form-item>
                            <a-select
                                    style="width: 120px"
                                    v-decorator="['state', {initialValue:initData.state, rules: [{ required: true, message: '请选择状态' }]}]">                            >
                                <a-select-option value="1">启用</a-select-option>
                                <a-select-option value="0">停用</a-select-option>
                            </a-select>
                        </a-form-item>
                    </td>
                </tr>
                <tr>
                    <th>备注：</th>
                    <td>
                        <a-form-item>
                            <a-textarea auto-size v-decorator="['remark', {initialValue:initData.remark}]"/>
                        </a-form-item>
                    </td>
                </tr>
            </table>
        </a-form>
    </a-modal>
</template>

<script>
  import qs from 'qs'
  import OrgSelector from '@/components/selector/OrgSelector'

  export default {
    created () {
      this.userName = this.$store.getters.nickname
    },
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    },
    components: {
      OrgSelector
    },
    data () {
      return {
        form: this.$form.createForm(this),
        queryParam: {},
        id: this.$route.query.id,
        modalLoading: false,
        params: {},
        loading: false,
        orgId: '',
        initData: {
          state: '1'
        },
        showUnitCodeEdit: false
      }
    },
    methods: {
      onsubmit () {
        let params = { ...this.form.getFieldsValue() }
        this.form.validateFields((err, values) => {
          if (err) {
            return
          }
          let that = this;
          that.modalLoading = true
          that.params.orgId = that.orgId
          this.$http.post('/api/v1/agency/insert.json',qs.stringify(params)).then(function (response) {
            that.modalLoading = false
            if (response.code === 200) {
              that.$message.success('添加成功')
              that.$emit('cancel')
            }
          })
        })
      },
      onOrgChange (selectedIds) {
        this.orgId = selectedIds
      },
      handleUseTypeChange(value){
        this.showUnitCodeEdit = value === '1'
      }
    }
  }
</script>
<style lang="less" scoped>
    .fx-form th {
        width: 100px;
    }
</style>
